// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34-Db","right":"styles_right__-_MqF"};